import { Button, Popover } from "@snpjs/core";

import { UserGuideMenu } from "./userGuideMenu/UserGuideMenu";
import { texts } from "../../i18n/texts";
import useTranslation from "../../hooks/useTranslation";

/**
 * User Guide Button.
 */
export const UserGuideButton: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Popover content={<UserGuideMenu />} placement="bottom-start">
        <Button
          text={t(texts.userGuide.userGuide)}
          icon="book-bookmark"
          rightIcon="caret-down"
          minimal={true}
        />
      </Popover>
    </>
  );
};
